



























































































import Vue from 'vue'
import SiteStatsCard, {
  SiteStatsCardType as siteStatsCardTypes,
  SiteStatsCardType,
} from '@/components/exec-dashboard/SiteStatsCard.vue'
import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import {
  ActionNames as SiteStatsActionNames,
  GetterNames as SiteStatsGetterNames,
} from '@/store/modules/site-stats/keys'
import { makeHorizontalChartOptions, makeVerticalChartOptions } from './chart-options'
import AnimatedNumber from 'animated-number-vue'
import { round as lodashRound } from 'lodash-es'
import { getCsvDownloadFunction } from '@/http/utils'
import { AppGetterNames } from '@/store/modules/app/keys'

export default Vue.extend({
  name: 'SiteStatsIndex',
  components: {
    SiteStatsCard,
    AnimatedNumber,
  },
  data() {
    return {
      isInitialLoading: true,
      dollar: 0,
      showTooltip1: false,
      showTooltip2: false,
      graphDirection: 'horizontal',
      downloadingTypes: [],
    }
  },
  computed: {
    ...mapGetters({
      siteStatses: `${ModuleNames.siteStats}/${SiteStatsGetterNames.siteStatses}`,
      isAdminUser: AppGetterNames.isAdminUser,
    }),
    siteStatsCardData() {
      return [
        {
          siteStatses: this.siteStatses,
          type: SiteStatsCardType.interactions,
          icon: 'mdi-download',
          iconLoading: this.downloadingTypes.includes(siteStatsCardTypes.interactions),
          iconEvents: {
            click: this.attachLoadingHandling({
              client: getCsvDownloadFunction({ path: `notes/` }),
              type: siteStatsCardTypes.interactions,
            }),
          },
        },
        {
          siteStatses: this.siteStatses,
          type: SiteStatsCardType.adherence,
        },
        {
          siteStatses: this.siteStatses,
          type: SiteStatsCardType.recruitment,
          icon: 'mdi-download',
          iconLoading: this.downloadingTypes.includes(siteStatsCardTypes.recruitment),
          iconEvents: {
            click: this.attachLoadingHandling({
              client: getCsvDownloadFunction({ path: `patients/` }),
              type: siteStatsCardTypes.recruitment,
            }),
          },
        },
        {
          siteStatses: this.siteStatses,
          type: SiteStatsCardType.events,
          icon: 'mdi-download',
          iconLoading: this.downloadingTypes.includes(siteStatsCardTypes.events),
          iconEvents: {
            click: this.attachLoadingHandling({
              client: getCsvDownloadFunction({ path: `events/` }),
              type: siteStatsCardTypes.events,
            }),
          },
        },
      ]
    },
    horizontalEChartOptions(): echarts.EChartOption<echarts.EChartOption.SeriesBar> {
      return makeHorizontalChartOptions({ vueScope: this })
    },
    verticalEChartOptions(): echarts.EChartOption<echarts.EChartOption.SeriesBar> {
      return makeVerticalChartOptions({ vueScope: this })
    },
  },
  async mounted(): Promise<void> {
    await Promise.all([this[SiteStatsActionNames.getSiteStatses]()])
    console.log(this.siteStatses)
    this.isInitialLoading = false
    this.dollar = 200000
  },
  methods: {
    ...mapActions(ModuleNames.siteStats, [SiteStatsActionNames.getSiteStatses]),
    formatValueMoney(value): string {
      return '$' + lodashRound(value).toLocaleString()
    },
    formatValuePercent(value): string {
      return lodashRound(value) + '%'
    },
    attachLoadingHandling(options: { client: () => Promise<void>; type: string }): () => void {
      return async () => {
        this.downloadingTypes.push(options.type)
        await options.client()
        this.downloadingTypes = this.downloadingTypes.filter(fileType => fileType !== options.type)
      }
    },
  },
})
